module.exports = __webpack_public_path__ + "media/assets/images/flags/bu-6ee49479e4ccc2c43f2b80bc65e3b66c.svg";